import { useEffect, useRef, useState } from 'react';

/** A word that slides out as its replacement slides in (e.g. TRADE LOG ⇄ TRADE STATS). */
export function SwapWord({ word, className }: { word: string; className?: string }) {
  const [shown, setShown] = useState(word);
  const [leaving, setLeaving] = useState<string | null>(null);
  const timer = useRef<number>();
  useEffect(() => {
    if (word === shown) return;
    setLeaving(shown);
    setShown(word);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setLeaving(null), 420);
  }, [word, shown]);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  return (
    <span style={{ position: 'relative', display: 'inline-block', verticalAlign: 'bottom' }}>
      <span key={shown} className={`${className ?? ''} pal-swap-in`} style={{ display: 'inline-block' }}>{shown}</span>
      {leaving && (
        <span key={`out-${leaving}`} aria-hidden className={`${className ?? ''} pal-swap-out`} style={{ position: 'absolute', left: 0, top: 0, display: 'inline-block' }}>{leaving}</span>
      )}
    </span>
  );
}
